import React from 'react'
import { useSelector } from 'react-redux'
import { t } from 'ttag'

import { AuthButton } from 'components/auth/common/AuthButton/AuthButton'
import { Form } from 'components/shared/Form/Form'

import { getLocation } from 'ducks/router'
import { useResetPasswordForm } from './hooks'
import { EMAIL_FIELD } from './model'

import styles from './../Form.module.scss'

export const ResetPasswordForm = () => {
  const location = useSelector(getLocation)

  const {
    payload: { done },
  } = location

  const { state, handlers } = useResetPasswordForm()

  const { control, formState } = state
  const { handleFormSubmit } = handlers

  if (done) {
    return (
      <>
        <h1 className={styles.title}>{t`Password reset sent`}</h1>
        <p className={styles.text}>
          {t`We've emailed you instructions for setting your password, if an account exists with the email you entered. You should receive them shortly. If you don't receive an email, please make sure you've entered the address you registered with, and check your spam folder.`}
        </p>
      </>
    )
  }

  return (
    <>
      <h1 className={styles.title}>{t`Password reset`}</h1>
      <p className={styles.text}>
        {t`Forgotten your password? Enter your email address below, and we'll email instructions for setting a new one.`}
      </p>
      <Form className={styles.form}>
        <Form.Field
          className={styles.field}
          error={formState.errors[EMAIL_FIELD]?.message}
          field="input"
          label={t`Email`}
          name={EMAIL_FIELD}
          type="email"
          {...{ control }}
        />
      </Form>
      <AuthButton
        className={styles.button}
        label={t`Reset my password`}
        variant="filled"
        onClick={handleFormSubmit}
      />
    </>
  )
}
